import { createSlice } from "@reduxjs/toolkit";

interface MenuState {
  sideMenuIsOpen: boolean;
  extraMenuIsOpen: boolean;
  advancedSearchIsOpen: boolean;
  headerHeight: number;
  sideMenuHeight: number;
}

const initialState: MenuState = {
  sideMenuIsOpen: false,
  extraMenuIsOpen: false,
  advancedSearchIsOpen: false,
  headerHeight: 90,
  sideMenuHeight: typeof window !== 'undefined' ? window.innerHeight - 90: 600,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setSideMenuIsOpen: (state: MenuState, action) => {
      state.sideMenuIsOpen = action.payload;
    },
    toggleSideMenuIsOpen: (state) => {
      state.sideMenuIsOpen = !state.sideMenuIsOpen;
    },
    setExtraMenuIsOpen: (state, action) => {
      state.extraMenuIsOpen = action.payload;
    },
    toggleExtraMenuIsOpen: (state) => {
      state.extraMenuIsOpen = !state.extraMenuIsOpen;
    },
    setAdvancedSearchIsOpen: (state, action) => {
      state.advancedSearchIsOpen = action.payload;
    },
    toggleAdvancedSearchIsOpen: (state) => {
      state.advancedSearchIsOpen = !state.advancedSearchIsOpen;
    },
    setHeaderHeight: (state: MenuState, action) => {
      state.headerHeight = action.payload;
    },
    setSideMenuHeight: (state: MenuState, action) => {
      state.sideMenuHeight = action.payload;
    },
  },
});

export const {
  setSideMenuIsOpen,
  toggleSideMenuIsOpen,
  setExtraMenuIsOpen,
  toggleExtraMenuIsOpen,
  setAdvancedSearchIsOpen,
  toggleAdvancedSearchIsOpen,
  setHeaderHeight,
  setSideMenuHeight
} = menuSlice.actions;

export default menuSlice.reducer;